import type { NewHomeRepository } from '../../domain/interfaces/NewHomeRepository';
import type { NewHomePageData } from '../../domain/models/NewHomePageData';
import type { NewHomePageDataDTO } from '../dto/newHome.dto';
import { adaptNewHomePageDataDtoToDomain } from '../mappers/newHome.mapper';
import newHomeData from '../../presentation/data/newHomeData.json';

/**
 * New Home Repository Adapter
 * Reads page layout/config from local JSON.
 * Product listing is handled by PLP's adapter (injected via build factory).
 */
export class newHomeAdapter implements NewHomeRepository {
  fetchPageDataSync(): NewHomePageData {
    const dto = newHomeData as unknown as NewHomePageDataDTO;
    return adaptNewHomePageDataDtoToDomain(dto);
  }

  async fetchPageData(): Promise<NewHomePageData> {
    return this.fetchPageDataSync();
  }
}
